import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Logo } from '../components/Logo';
export function TermsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#f2efeb] text-[#2b2826] font-sans" data-id="element-892">
      {/* Header */}
      <header className="border-b border-[#2b2826]/10" data-id="element-893">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 py-5 flex items-center justify-between" data-id="element-894">
          <Link to="/" aria-label="ScaleWithLending home" data-id="element-895">
            <Logo data-id="element-896" />
          </Link>
          <Link to="/" className="text-sm text-[#2b2826]/70 hover:text-[#2b2826] transition-colors flex items-center gap-2" data-id="element-897">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-898" />
            Back to home
          </Link>
        </div>
      </header>

      {/* Main */}
      <main className="max-w-3xl mx-auto px-6 sm:px-8 py-16 sm:py-20" data-id="element-899">
        <div className="mb-12 pb-10 border-b border-[#2b2826]/10" data-id="element-900">
          <p className="text-xs uppercase tracking-[0.2em] text-[#c9a875] font-medium mb-4" data-id="element-901">
            Legal
          </p>
          <h1 className="font-serif-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] text-[#2b2826] mb-4" data-id="element-902">
            Terms of <span className="italic text-[#c9a875]" data-id="element-903">Service</span>
          </h1>
          <p className="text-sm text-[#2b2826]/60" data-id="element-904">Last updated: May 8, 2026</p>
        </div>

        <article className="space-y-10 text-[#2b2826]/85 leading-relaxed" data-id="element-905">
          <div data-id="element-906">
            <p className="text-base" data-id="element-907">
              These Terms of Service ("Terms") govern your access to and use of
              scalewithlending.com (the "Site") and any services provided by{' '}
              <strong data-id="element-908">TRU OFFER LLC</strong> (doing business as
              ScaleWithLending, "we," "us," or "our"). By using the Site or
              submitting a funding request, you agree to these Terms.
            </p>
          </div>

          <div data-id="element-909">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-910">
              1. Our Services
            </h2>
            <p data-id="element-911">
              ScaleWithLending provides transactional funding solutions for real
              estate investors and wholesalers, including earnest money deposit
              (EMD) lending, double-close funding, joint-venture partnerships,
              and related advisory services. Specific terms, fees, and
              conditions for each transaction are set forth in separate written
              agreements between you and us.
            </p>
          </div>

          <div data-id="element-912">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-913">
              2. Eligibility
            </h2>
            <p data-id="element-914">
              You must be at least 18 years old, have the legal capacity to
              enter into binding agreements, and act in your individual or
              authorized business capacity to use our services. By submitting a
              funding request, you represent that all information you provide is
              accurate and complete.
            </p>
          </div>

          <div data-id="element-915">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-916">
              3. No Guarantee of Funding
            </h2>
            <p data-id="element-917">
              Submission of a funding request does not constitute a commitment,
              offer, or obligation by us to fund your deal. All funding requests
              are subject to our underwriting review, due diligence, and final
              approval at our sole discretion. We may decline any request
              without explanation.
            </p>
          </div>

          <div data-id="element-918">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-919">
              4. Fees and Costs
            </h2>
            <p data-id="element-920">
              When we agree to fund a transaction, applicable fees, interest
              rates, and timelines are disclosed in a separate term sheet or
              funding agreement that you must sign before any funds are wired.
              Upfront diligence fees, if charged, may be non-refundable as
              specified in writing.
            </p>
          </div>

          <div data-id="element-921">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-922">
              5. Not Legal, Tax, or Investment Advice
            </h2>
            <p data-id="element-923">
              Content on the Site (including blog articles, guides, and any
              communication from our team) is provided for informational
              purposes only and does not constitute legal, tax, accounting,
              financial, or investment advice. You should consult qualified
              professionals before making any decisions based on information
              from this Site.
            </p>
          </div>

          <div data-id="element-924">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-925">
              6. Your Responsibilities
            </h2>
            <p className="mb-4" data-id="element-926">By using our services, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2 text-[#2b2826]/80" data-id="element-927">
              <li data-id="element-928">
                Provide truthful, accurate, and complete information in your
                application and any related communications.
              </li>
              <li data-id="element-929">
                Comply with all applicable federal, state, and local laws
                governing your real estate transactions, including wholesaling,
                licensing, and disclosure laws in your operating jurisdiction.
              </li>
              <li data-id="element-930">
                Hold harmless TRU OFFER LLC from any losses, claims, or damages
                arising from misrepresentations in your application or
                violations of law in your underlying transaction.
              </li>
            </ul>
          </div>

          <div data-id="element-931">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-932">
              7. Intellectual Property
            </h2>
            <p data-id="element-933">
              All content on the Site — including text, graphics, logos,
              articles, and the ScaleWithLending name and brand — is owned by or
              licensed to TRU OFFER LLC and is protected by intellectual
              property laws. You may not copy, reproduce, or distribute Site
              content without our prior written permission.
            </p>
          </div>

          <div data-id="element-934">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-935">
              8. Limitation of Liability
            </h2>
            <p data-id="element-936">
              To the maximum extent permitted by law, TRU OFFER LLC, its
              members, employees, and affiliates shall not be liable for any
              indirect, incidental, special, consequential, or punitive damages
              arising out of or related to your use of the Site or our services.
              Our total aggregate liability for any claim shall not exceed the
              fees you have paid to us in the twelve (12) months preceding the
              event giving rise to the claim.
            </p>
          </div>

          <div data-id="element-937">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-938">
              9. Indemnification
            </h2>
            <p data-id="element-939">
              You agree to indemnify and hold harmless TRU OFFER LLC and its
              affiliates from any claims, damages, losses, or expenses
              (including reasonable attorneys' fees) arising from your breach of
              these Terms, your misrepresentations, or your underlying real
              estate transaction.
            </p>
          </div>

          <div data-id="element-940">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-941">
              10. Governing Law and Dispute Resolution
            </h2>
            <p data-id="element-942">
              These Terms are governed by and construed in accordance with the
              laws of the State of Florida, without regard to its
              conflict-of-laws principles. Any dispute arising out of or
              relating to these Terms or our services shall be resolved through
              binding arbitration administered by the American Arbitration
              Association under its Commercial Arbitration Rules. The
              arbitration shall take place in the county in Florida where TRU
              OFFER LLC maintains its principal place of business, unless
              otherwise agreed in writing. Judgment on the arbitration award may
              be entered in any court of competent jurisdiction in the State of
              Florida.
            </p>
          </div>

          <div data-id="element-943">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-944">
              11. Changes to These Terms
            </h2>
            <p data-id="element-945">
              We may update these Terms at any time. The "Last updated" date at
              the top of this page indicates the most recent revision. Continued
              use of the Site after changes are posted constitutes acceptance of
              the revised Terms.
            </p>
          </div>

          <div data-id="element-946">
            <h2 className="font-serif-display text-2xl text-[#2b2826] mb-4" data-id="element-947">
              12. Contact
            </h2>
            <p data-id="element-948">For questions about these Terms, contact:</p>
            <div className="mt-4 bg-white border border-[#2b2826]/10 rounded-2xl p-6" data-id="element-949">
              <p className="font-medium text-[#2b2826]" data-id="element-950">TRU OFFER LLC</p>
              <p className="text-[#2b2826]/70 text-sm mt-1" data-id="element-951">
                d/b/a ScaleWithLending
              </p>
              <p className="text-[#2b2826]/70 text-sm mt-3" data-id="element-952">
                Email:{' '}
                <a href="mailto:support@truoffer.co" className="text-[#c9a875] underline hover:no-underline" data-id="element-953">
                  support@truoffer.co
                </a>
              </p>
            </div>
          </div>
        </article>
      </main>

      {/* Footer */}
      <footer className="border-t border-[#2b2826]/10 mt-12" data-id="element-954">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#2b2826]/50" data-id="element-955">
          <span data-id="element-956">
            © {new Date().getFullYear()} TRU OFFER LLC. All rights reserved.
          </span>
          <div className="flex gap-5" data-id="element-957">
            <Link to="/privacy" className="hover:text-[#2b2826] transition-colors" data-id="element-958">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-[#2b2826] transition-colors" data-id="element-959">
              Terms
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}